"use client";

import { useEffect } from "react";
import { reportClientError } from "@/lib/observability/client-error-reporter";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      console.error("Global error:", error);
    }
    reportClientError({
      message: error.message || "Global error",
      name: error.name,
      stack: error.stack,
      digest: error.digest,
      severity: "fatal",
      context: { boundary: "app/global-error.tsx" },
    });
  }, [error]);

  return (
    <html>
      <body>
        <div style={{ padding: "20px", fontFamily: "system-ui, sans-serif" }}>
          <h1>Something went wrong</h1>
          <p>An unexpected error occurred. Please try refreshing the page.</p>
          {process.env.NODE_ENV === "development" && (
            <details style={{ marginTop: "20px", whiteSpace: "pre-wrap" }}>
              <summary>Error details (development only)</summary>
              <p>{error.message}</p>
              {error.digest && <p>Digest: {error.digest}</p>}
            </details>
          )}
        </div>
      </body>
    </html>
  );
}
